import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "10",
  viewBox: "0 0 18 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--_dn-icon_color)",
      d: "M18 5.655C16.03 4.562 13.716 2.044 12.928 0h-1.823c.862 2.115 2.832 4.253 4.31 5.275H0v1.497h15.415C13.912 7.794 11.943 9.885 11.13 12h1.797c.764-2.044 3.079-4.515 5.073-5.608z"
    }, null, -1)
  ]))]))
}
export default { render: render }